import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ResumeFileLinksSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function ResumeFileLinksSubTab() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFiles = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/processed-resume-files`);
      setList(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка загрузки: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  return (
    <div className="resume-file-links-sub-tab">
      <div className="tab-header">
        <h2>Ссылки на PDF резюме в S3</h2>
        <button type="button" className="btn btn-secondary" onClick={fetchFiles} disabled={loading}>
          Обновить
        </button>
      </div>
      <p className="tab-description">
        Записи создаются при отправке на обработку резюме с приложенным PDF (подвкладка «Парсинг резюме»).
      </p>
      {error && <div className="error-message">{error}</div>}
      {loading ? (
        <div className="loading">Загрузка...</div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>ID обработанного резюме</th>
                <th>Профессия</th>
                <th>Ссылка на PDF</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 ? (
                <tr>
                  <td colSpan="4" className="empty-state">
                    Нет записей. Загрузите PDF в подвкладке «Парсинг резюме» и отправьте текст на обработку с приложенным файлом.
                  </td>
                </tr>
              ) : (
                list.map((row) => (
                  <tr key={row.id}>
                    <td>{row.id}</td>
                    <td>{row.processed_resume_id}</td>
                    <td>{row.profession || '—'}</td>
                    <td className="cell-link">
                      <a href={row.s3_url} target="_blank" rel="noopener noreferrer" title={row.s3_url}>
                        Открыть PDF
                      </a>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ResumeFileLinksSubTab;
